import { useEffect, useState } from "react";
import nodeinstance from "../../../../../nodeInstance";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../../store/userSlice";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import React from "react";

export default function Emergency_extension({
  PopUp,
  setPopUp,
  popUpData,
  setTrigger,
  trigger,
  routeType,
}) {
  console.log("sdghtyfgyt..........", popUpData);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [selectedOption, setSelectedOption] = useState({
    extension_govt_cost: "",
    extension_salary: "",
    extension_ere_type: "",
    extension_client_fees: "",
    extension_total_amount: "",
    extension_sla_fees: "",
    extension_employee_fees: "",
  });
  console.log("popUpData..........", popUpData);
  const handleOptionChange = (event) => {
    const { name, value } = event.target;
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      [name]: value,
    }));
  };
  const [daysUntilExpiry, setDaysUntilExpiry] = useState(null);

  const [data, setData] = useState();

  const response = async () => {
    const endPoint =
      routeType === "Emergency_leave"
        ? `/ere/getDetails/${popUpData?.candidate_id}`
        : routeType === "Annual_Vacation"
          ? `/employeeAnnualvacation/getEmpDetails/${popUpData?.candidate_id}`
          : "";

    try {
      const res = await nodeinstance.get(`${endPoint}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.status === 200) {
        setData(res?.data?.data);
      }
    } catch (error) {
      console.log("error.........", error);
      dispatch(
        setAppError({
          msg: "failed to get the data",
        })
      );
    }
  };

  useEffect(() => {
    const calculateDaysUntilExpiry = () => {
      const expiryDate = new Date(popUpData?.iqama_expiry_date_g);
      const today = new Date();

      const timeDifference = expiryDate - today; // Difference in milliseconds
      const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days and round up

      setDaysUntilExpiry(daysDifference);
      response();
    };

    calculateDaysUntilExpiry();
  }, []);

  useEffect(() => {
    setSelectedOption((prevSelectedOption) => ({
      ...prevSelectedOption,
      extension_total_amount: data?.extension_total_amount,
      extension_sla_fees: data?.extension_sla_fees,
    }));
  }, [data]);
  console.log("jjjjjjj............", selectedOption);
  const token = localStorage.getItem("nodeToken");

  const dispatch = useDispatch();

  const submitHandler = async (e, fileData) => {
    console.log("fileData......", selectedOption);
    e.preventDefault();
    // setLoading(true);
    const endPoint =
      routeType === "Emergency_leave"
        ? "/ere/extensionFinance"
        : routeType === "Annual_Vacation"
          ? "/employeeAnnualvacation/annualVacationFinance"
          : "";
    if (selectedOption?.extension_sla_fees != "BORNE") {
      dispatch(
        setAppError({
          msg: "Change sla_fees status to borne",
        })
      );
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("employee_id", popUpData?.candidate_id);
      formData.append(
        "extension_total_amount",
        selectedOption?.extension_total_amount
      );
      formData.append("extension_sla_fees", selectedOption?.extension_sla_fees);
      formData.append("emergency_leave_status", "ON ERE-PAYMENT DONE");
      const response = await nodeinstance.put(`${endPoint}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        dispatch(
          setAppError({
            msg: "Updated successfully....",
            color: "success",
          })
        );
        setTrigger(!trigger);
        setPopUp(false);
      }
    } catch (err) {
      console.log("error", err);
      dispatch(
        setAppError({
          msg: "Error while updating data..",
        })
      );
    }
  };

  console.log("daysUntilExpiry......", data);

  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          PopUp ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-2xl max-h-[45rem]  w-full h-auto mt-4 rounded-md overflow-scroll bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          {/* First Sheet */}
          <>
            <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
              <div className="bg-orange-50 p-3 ">
                <div className="flex items-center space-x-8 font-bold">
                  <label>PAYROLL & BILLING</label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">GOVT. COST:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_govt_cost"
                        value="BORNE BY CLIENT"
                        checked={
                          selectedOption?.extension_govt_cost ===
                            "BORNE BY CLIENT" ||
                          data?.extension_govt_cost === "BORNE BY CLIENT"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> BORNE BY CLIENT</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        value="BORNE BY SLA"
                        name="extension_govt_cost"
                        checked={
                          selectedOption?.extension_govt_cost ===
                            "BORNE BY SLA" ||
                          data?.extension_govt_cost === "BORNE BY SLA"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> BORNE BY SLA</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
                <div className="flex gap-2">
                  <label className="pr-2">SALARY:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_salary"
                        value="PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOption?.extension_salary ===
                            "PAYABLE TO EMPLOYEE" ||
                          data?.extension_salary === "PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> PAYABLE TO EMPLOYEE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_salary"
                        value="NOT PAYABLE TO EMPLOYEE"
                        checked={
                          selectedOption?.extension_salary ===
                            "NOT PAYABLE TO EMPLOYEE" ||
                          data?.extension_salary === "NOT PAYABLE TO EMPLOYEE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> NOT PAYABLE TO EMPLOYEE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>
              </div>
              <br />
              {/* Second face */}
              <div className="bg-orange-50 p-3">
                <div className="flex items-center space-x-2 ">
                  <label className="font-bold">ERE TYPE</label>
                  <label>COUNT OF PAST ERE INSTANCE: 1</label>
                </div>
                <div className="flex gap-2 mb-2 mt-2">
                  <label className="pr-2">TYPE:</label>

                  <div className="flex gap-5">
                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_ere_type"
                        value="SINGLE"
                        checked={
                          selectedOption?.extension_ere_type === "SINGLE" ||
                          data?.extension_ere_type === "SINGLE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> SINGLE</p>
                    </label>

                    <label className="flex gap-x-1">
                      <input
                        type="radio"
                        name="extension_ere_type"
                        value="MULTIPLE"
                        checked={
                          selectedOption?.extension_ere_type === "MULTIPLE" ||
                          data?.extension_ere_type === "MULTIPLE"
                        }
                        onChange={handleOptionChange}
                        disabled
                      />
                      <p> MULTIPLE</p>
                    </label>
                  </div>
                  {/* <p>Selected option: {selectedOption}</p> */}
                </div>

                <div className="flex flex-wrap items-center">
                  <label className="mr-2">DURATION:</label>
                  <input
                    type="text"
                    className={`input input-sm h-8 max-w-xs 
                            input-bordered focus:outline-none uppercase`}
                    required
                    value={daysUntilExpiry}
                    disabled
                    // onChange={(e) => {}}
                  />
                  <label className="block font-xs uppercase ml-2 text-xs">
                    IQAMA Valid days remaining: <br /> (today-current IQAMA
                    expiry)
                  </label>
                </div>
              </div>
              <br />
              {/* Second face */}
              <div className="bg-orange-50 p-3">
                <div className="items-center space-x-2 ">
                  <label className="font-bold">FEES</label>
                </div>
                <div className="flex">
                  <div className=" mr-16">
                    <div className="flex gap-2 mb-4 mt-4">
                      <label className="pr-2">Client:</label>

                      <div className="flex gap-5 ">
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="extension_client_fees"
                            value="BORNE"
                            checked={
                              selectedOption?.extension_client_fees ===
                                "BORNE" ||
                              data?.extension_client_fees === "BORNE"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> BORNE</p>
                        </label>

                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="extension_client_fees"
                            value="PAID"
                            checked={
                              selectedOption?.extension_client_fees ===
                                "PAID" || data?.extension_client_fees === "PAID"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> PAID</p>
                        </label>
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>

                    <div className="flex gap-2 mb-4 mt-4">
                      <label className="pr-2">SLA:</label>

                      <div className="flex gap-5">
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="extension_sla_fees"
                            value="BORNE"
                            checked={
                              selectedOption?.extension_sla_fees === "BORNE"
                            }
                            onChange={handleOptionChange}
                          />
                          <p> BORNE</p>
                        </label>

                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="extension_sla_fees"
                            value="TO BE PAID"
                            checked={
                              selectedOption?.extension_sla_fees ===
                              "TO BE PAID"
                            }
                            onChange={handleOptionChange}
                          />
                          <p>TO BE PAID</p>
                        </label>
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>

                    <div className="flex gap-2 mb-4 mt-4">
                      <label className="pr-2">EMPLOYEE:</label>

                      <div className="flex gap-5">
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="extension_employee_fees"
                            value="BORNE"
                            checked={
                              selectedOption?.extension_employee_fees ===
                                "BORNE" ||
                              data?.extension_employee_fees === "BORNE"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> BORNE</p>
                        </label>
                        <label className="flex gap-x-1">
                          <input
                            type="radio"
                            name="extension_employee_fees"
                            value="PAID"
                            checked={
                              selectedOption?.extension_employee_fees ===
                                "PAID" ||
                              data?.extension_employee_fees === "PAID"
                            }
                            onChange={handleOptionChange}
                            disabled
                          />
                          <p> PAID</p>
                        </label>
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>
                  </div>
                  <div>
                    <div className="gap-2">
                      <h2 className="label place-items-center font-bold">
                        TOTAL AMOUNT
                      </h2>

                      <div className="gap-5">
                        <input
                          type="number"
                          name="extension_total_amount"
                          className={`input input-sm h-8 max-w-xs  w-full 
                        input-bordered focus:outline-none uppercase mb-2`}
                          required="er"
                          value={parseInt(
                            selectedOption?.extension_total_amount
                          )}
                          onChange={handleOptionChange}
                          // onChange={}
                        />
                        <input
                          type="file"
                          className="file-input file-input-bordered w-full h-10"
                          onChange={(e) => setFile(e.target.files[0])}
                          required
                          accept="application/xls, application/xlsx"
                        />
                      </div>
                      {/* <p>Selected option: {selectedOption}</p> */}
                    </div>
                  </div>
                </div>
              </div>
              <br />

              <br />

              <div className="flex w-full">
                <div className="w-full flex flex-col gap-3">
                  <div className="flex gap-3 w-full justify-center">
                    <button
                      className="p-3 bg-red text-white rounded-md w-full max-w-xs m-2 my-4 flex gap-3 justify-center items-center text-sm"
                      type="submit"
                    >
                      <p>Submit</p>
                      {loading ? <CgSpinner className="animate-spin" /> : ""}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </>
        </div>
      </div>
    </>
  );
}
